export default __webpack_public_path__ + "static/media/qr_code-24px.f389dc8d.svg";